import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Formatter {
    isLoading: boolean;
    error: string | null;
    data: null;
}

const initialState: Formatter = {
    data: null,
    isLoading: false,
    error: null
};

const formatterSlice = createSlice({
    name: 'reFormatter',
    initialState,
    reducers: {
        setReFormatter: (state: Formatter, action) => {
            state.data = action.payload;
            state.isLoading = false;
            state.error = null;
        },
        setloading: (state: Formatter, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
            state.error = null;
        },
        seterror: (state: Formatter, action: PayloadAction<string>) => {
            state.error = action.payload;
            state.isLoading = false;
        },
        resetReFormatter: () => {
            return initialState;
        },
    },
});

export const { setReFormatter, setloading, seterror, resetReFormatter } = formatterSlice.actions;

export default formatterSlice.reducer;
